import React, { useState, useEffect } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import FloorNavigation from './components/FloorNavigation';
import UnitGrid from './components/UnitGrid';
import InquiryDrawer from './components/InquiryDrawer';
import VirtualTour from './components/VirtualTour';
import HomePage from './components/HomePage';
import LocationPage from './components/LocationPage';
import ImageModal from './components/ImageModal';
import WellnessPage from './components/WellnessPage';


import { generateUnits } from './utils/unitData';


const App = () => {
  const [activeFloor, setActiveFloor] = useState(1);
  const [view, setView] = useState(() => localStorage.getItem('currentView') || 'home');
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [units, setUnits] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [availabilityResponse, pricesResponse] = await Promise.all([
          fetch('/availability.json'),
          fetch('/prices.json')
        ]);
        const availabilityData = await availabilityResponse.json();
        const pricesData = await pricesResponse.json();
        
        const allGeneratedUnits = generateUnits(pricesData);
        const availableIds = new Set(availabilityData.available);
        const reservedIds = new Set(availabilityData.reserved);

        const unitsWithStatus = allGeneratedUnits.map(unit => {
          let status = 'sold';
          if (availableIds.has(unit.id)) {
            status = 'available';
          } else if (reservedIds.has(unit.id)) {
            status = 'reserved';
          }
          return { ...unit, status };
        });

        setUnits(unitsWithStatus);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const floorUnits = units.filter(u => u.floor === activeFloor);

  const setViewAndStorage = (newView) => {
    localStorage.setItem('currentView', newView);
    setView(newView);
  };

  return (
    <div className="app-wrapper">
      <Sidebar view={view} setView={setViewAndStorage} />

      <main className="main-stage">
        {view === 'home' ? (
          <HomePage />
        ) : view === 'inventory' ? (
          <>
            <FloorNavigation activeFloor={activeFloor} setActiveFloor={setActiveFloor} />
            <UnitGrid
              units={floorUnits}
              onInquire={setSelectedUnit}
              onImageClick={setSelectedImage}
              onVideoClick={unit => {
                // Map unit.image to video file (e.g., /images/01.mp4, /images/02.mp4, ...)
                let num = '01';
                if (unit.image) {
                  const match = unit.image.match(/(\d+)/);
                  if (match) num = match[1].padStart(2, '0');
                }
                setSelectedVideo(`/images/${num}.mp4`);
              }}
            />
          </>
        ) : view === 'tour' ? (
          <VirtualTour />
        ) : view === 'location' ? (
          <LocationPage />
        ) : view === 'wellness' ? (
          <WellnessPage />
        ) : null}
      </main>

      {selectedUnit && (
        <InquiryDrawer unit={selectedUnit} onClose={() => setSelectedUnit(null)} />
      )}
      <ImageModal imageUrl={selectedImage} onClose={() => setSelectedImage(null)} />
      <ImageModal imageUrl={selectedVideo} isVideo={true} onClose={() => setSelectedVideo(null)} />
    </div>
  );
};

export default App;